import React from 'react';
import Svg, { G, Path } from 'react-native-svg';
const getActiveColor = (amount) => {
    if (amount < 2)
        return '#FF3722';
    if (amount < 3)
        return '#FF8622';
    if (amount < 4)
        return '#FFCE00';
    if (amount < 4.5)
        return '#73CF11';
    return '#00B67A';
};
const Stars = ({ amount = 0, width = 80, height = 30, }) => {
    const activeColor = getActiveColor(amount);
    const getIColor = (index) => index > amount ? '#DCDCE6' : activeColor;
    const flooredX = Math.floor(amount) * 104;
    return (<Svg width={width} height={height} viewBox="0 0 512 96">
      <G fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <G fillRule="nonzero">
          <Path fill={getIColor(1)} d="M0 0H96V96H0z"/>
          <Path fill={getIColor(2)} d="M104 0H200V96H104z"/>
          <Path fill={getIColor(3)} d="M208 0H304V96H208z"/>
          <Path fill={getIColor(4)} d="M312 0H408V96H312z"/>
          <Path fill={getIColor(5)} d="M416 0H512V96H416z"/>

          {amount % 1 > 0 && (<Path fill={activeColor} d={`M${flooredX} 0H${flooredX + Math.floor((amount % 1) * 96)}V96H${flooredX}`}/>)}
          <Path fill="#FFF" d="M48 64.7L62.6 61l6.1 18.8L48 64.7zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM152 64.7l14.6-3.7 6.1 18.8L152 64.7zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM256 64.7l14.6-3.7 6.1 18.8L256 64.7zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM360 64.7l14.6-3.7 6.1 18.8L360 64.7zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15zM464 64.7l14.6-3.7 6.1 18.8L464 64.7zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2 20.7-15z"/>
        </G>
      </G>
    </Svg>);
};
export default Stars;
